import { useState, useEffect } from "react";
import { createPublicClient, getVideo } from "@seeen/api";
import type { Video } from "@seeen/api";

type State =
  | { status: "idle" }
  | { status: "loading" }
  | { status: "success"; video: Video }
  | { status: "error"; error: Error };

export function useApiVideo(
  apiKey: string | null,
  videoId: string | null,
): State {
  const [state, setState] = useState<State>({
    status: apiKey && videoId ? "loading" : "idle",
  });

  useEffect(() => {
    if (!apiKey || !videoId) return;
    setState({ status: "loading" });
    const client = createPublicClient({ apiKey });
    getVideo(client, videoId)
      .then((video) => setState({ status: "success", video }))
      .catch((error) =>
        setState({
          status: "error",
          error: error instanceof Error ? error : new Error(String(error)),
        }),
      );
  }, [apiKey, videoId]);

  return state;
}
